import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'constants';

class TeamWasSetForEachStackItemValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {legacyControlledHitterStacking} = this.dependencies;

        const firstGroupItems = legacyControlledHitterStacking.getFirstGroupItems();

        this.validateTeamInItems(firstGroupItems);

        if (this.hasErrors() || !legacyControlledHitterStacking.isDoubleStackModeEnabled()) {
            return;
        }

        const secondGroupItems = legacyControlledHitterStacking.getSecondGroupItems();

        this.validateTeamInItems(secondGroupItems);
    }

    private validateTeamInItems(items): void {
        for (let item of items) {
            if (!item.team) {
                this.addError('A team in the hitter stack has to be specified, please check.');
                break;
            }
        }
    }
}

export default TeamWasSetForEachStackItemValidator;
